import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentPencilRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.6 9.6c0-1.3 1-2.4 2.4-2.4h16c1.3 0 2.4 1 2.4 2.4v11.2c0 1.3-1 2.4-2.4 2.4h-6q-.8 0-1.4.4L12 27v-2.5q0-1.1-1.2-1.2H8c-1.3 0-2.4-1-2.4-2.4zM8 4.8a5 5 0 0 0-4.8 4.8v11.2c0 2.6 2.1 4.8 4.8 4.8h1.6v3.6q0 .7.6 1t1.3 0l6.5-4.6h6c2.6 0 4.8-2.2 4.8-4.8V9.6c0-2.7-2.2-4.8-4.8-4.8zm2.4 15.1v.2a.7.7 0 0 0 .9.7l2.5-.6q.7-.2 1-.7l6.1-6a2.3 2.3 0 1 0-3.2-3.2l-6 6q-.5.5-.7 1.1z" })
});
export default SvgCommentPencilRegularIcon;
